import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {ConfirmPopUpFinzyFlexComponent} from './confirm-pop-up-finzy-flex.component';
import {ConfirmPopUpFinzyFlexSkeletonComponent} from './skeleton/confirm-pop-up-finzy-flex-skeleton.component';

@NgModule({
    entryComponents: [ConfirmPopUpFinzyFlexComponent],
    imports: [CommonModule, MatButtonModule, MatDialogModule],
    exports: [ConfirmPopUpFinzyFlexComponent, ConfirmPopUpFinzyFlexSkeletonComponent],
    declarations: [ConfirmPopUpFinzyFlexComponent, ConfirmPopUpFinzyFlexSkeletonComponent]
})
export class ConfirmPopUpFinzyFlexModule {
}
